import {useState,useEffect} from 'react'
import '../css/custom.css'
import '../css/page.min.css'
import '../css/style.css'
import '../css/contact.css'












const Privacy = ()=>{

useEffect(()=>{
    document.title = 'Boltzmann | Privacy'
    window.scrollTo(0, 0)
})






return(

<main class="main-content" id="privacy" >

<section id="section-features" class="features-section" style ={{backgroundColor: 'white'}}>

    <div class="container" style={{color: "#501f84",marginTop:'120px'}} >

        <h3 style={{textAlign: "center", color:"#501f84",fontFamily: "Inter,sans-serif",fontWeight: "bold",marginTop: "5%",}}>Privacy Policy</h3>

        <span style={{fontWeight: "bold",color:'#501f84'}}>Last Update: June 2021</span>

        <p class="priv-p" style ={{color: '#501f84'}}>BOLTZMANN Labs Private Limited (hereafter referred to as BOLTZMANN Labs) (“us”, “we”, or “our”)

            operates the Boltzmann (www.boltzmann.co ) website (the “Service”) and related websites including

            but not limited to BoltChem (www.boltchem.com, www.app.boltchem.com ).</p>

        <p class="priv-p" style ={{color: '#501f84'}}>This page informs you of our policies regarding the collection, use, and disclosure of personal data

            when you use our Service and the choices you have associated with that data.</p>

        <p class="priv-p" style ={{color: '#501f84'}}>We use your data to provide and improve the Service. By using the Service, you agree to the

            collection and use of information in accordance with this policy. Unless otherwise defined in this

            Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and

            Conditions, accessible from our website. </p>

        <h3 class="priv-h3"style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Definitions</h3>

        <h4 class="priv-h4"style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Service</h4>

        <p>Services are the websites that operate under BOLTZMANN Labs.</p>

        <h4 class="priv-h4"style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Personal Data </h4>

        <p class="priv-p"style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Personal Data means data about a living individual who can be identified from that data (or from

            those and other information either in our possession or likely to come into our possession).</p>

        <h4 class="priv-h4"style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Usage Data </h4>

        <p class="priv-h4"style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Usage Data is data collected automatically either generated by the use of the Service or from the

            Service infrastructure itself (for example, the duration of a page visit).</p>

        <h4 class="priv-h4" style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Cookies</h4>

        Cookies are small pieces of data stored on your device (computer or mobile device).

        <h4 class="priv-h4"style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Data Controller</h4>

        <p>Data Controller means the natural or legal person who (either alone or jointly or in common with

            other persons) determines the purposes for which and the manner in which any personal information

            is, or are to be, processed.

            For the purpose of this Privacy Policy, we are a Data Controller of your Personal Data.</p>

        <h4 class="priv-h4"style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Data Processors (or Service Providers)</h4>

        <p>Data Processor (or Service Provider) means any natural or legal person who processes the data on

            behalf of the Data Controller. </p>

        <span>We may use the services of various Service Providers in order to process your data more

            effectively. </span>

        <h4 class="priv-h4" style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Data Subject (or User) </h4>

        <p>Data Subject is any living individual who is using our Service and is the subject of Personal Data.

        </p>

        <h4 class="priv-h4"style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Information Collection and Use</h4>

        <p>We collect several different types of information for various purposes to provide and improve our

            Service to you. </p>

        <h3 class="priv-h3"style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Types of Data Collected</h3>

        <h4 class="priv-h4"style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Personal Data </h4>

        <p>While using our Service, we may ask you to provide us with certain personally identifiable

            information that can be used to contact or identify you (“Personal Data”). Personally identifiable

            information may include, but is not limited to:</p>

        <ul>

            <li>Email address</li>

            <li>First name and last name </li>

            <li>Phone number</li>

            <li>Cookies and Usage Data </li>

        </ul>









        <span>We may use your Personal Data to contact you with newsletters, marketing or promotional materials

            and other information that may be of interest to you. You may opt out of receiving any, or all, of

            these communications from us by contacting us. </span>

        <h4 class="priv-h4"style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Usage Data </h4>

        <p>We may also collect information on how the Service is accessed and used (“Usage Data”). This Usage

            Data may include information such as your computer’s Internet Protocol address (e.g. IP address),

            browser type, browser version, the pages of our Service that you visit, the time and date of your

            visit, the time spent on those pages, unique device identifiers and other diagnostic data. </p>

        <h4 class="priv-h4" style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Tracking & Cookies Data</h4>

        <p>We use cookies and similar tracking technologies to track the activity on our Service and hold

            certain information.

            Cookies are files with little amount of data which may include an anonymous unique identifier.

            Cookies are sent to your browser from a website and stored on your device. Tracking technologies

            also used are beacons, tags, and scripts to collect and track information and to improve and analyze

            our Service.</p>

        <p>You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.

            However, if you do not accept cookies, you may not be able to use some portions of our Service. </p>

        <h4 class="priv-h4"style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}> Examples of Cookies we use: </h4>

        <span>Session Cookies.</span>

        <p> We use Session Cookies to operate our Service.</p>

        <span>Preference Cookies.</span>

        <p> We use Preference Cookies to remember your preferences and various

            settings. </p>

        <span>Security Cookies.</span>

        <p> We use Security Cookies for security purposes.</p>



        <h4 class="priv-h4" style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Use of Data </h4>

        <p>BOLTZMANN Labs uses the collected data for various purposes: </p>

        <ul>

            <li>To provide and maintain our Service.

            </li>

            <li>To notify you about changes to our Service.

            </li>

            <li>To allow you to participate in interactive features of our Service when you choose to do so.

            </li>

            <li>To provide customer support.

            </li>

            <li>To gather analysis or valuable information so that we can improve our Service.

            </li>

            <li>To monitor the usage of our Service.

            </li>

            <li>To detect, prevent and address technical issues.</li>

            <li>To provide you with news, special offers and general information about other goods, services and

                events which we offer that are similar to those that you have already purchased or enquired

                about unless you have opted not to receive such information.

            </li>



        </ul>



        <h4 class="priv-h4" style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Legal Basis for Processing Personal Data Under General Data Protection Regulation (GDPR)</h4>

        <p>If you are from the European Economic Area (EEA), BOLTZMANN Labs legal basis for collecting and using

            the personal information described in this Privacy Policy depends on the Personal Data we collect

            and

            the specific context in which we collect it.</p>

        <p>BOLTZMANN Labs may process your Personal Data because:</p>

        <ul>

            <li>We need to perform a contract with you

            </li>

            <li>You have given us permission to do so

            </li>

            <li>The processing is in our legitimate interests and it’s not overridden by your rights

            </li>

            <li>To comply with the law

            </li>

        </ul>

        <h4 class="priv-h4" style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Retention of Data</h4>

        <p>BOLTZMANN Labs will retain your Personal Data only for as long as is necessary for the purposes set

            out

            in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply

            with

            our legal obligations (for example, if we are required to retain your data to comply with applicable

            laws), resolve disputes, and enforce our legal agreements and policies.</p>



        <p>BOLTZMANN Labs will also retain Usage Data for internal analysis purposes. Usage Data is generally

            retained for a shorter period of time, except when this data is used to strengthen the security or

            to

            improve the functionality of our Service, or we are legally obligated to retain this data for longer

            time periods.</p>

        <h4 class="priv-h4" style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Transfer of Data </h4>

        <p>Your information, including Personal Data, may be transferred to – and maintained on – computers

            located outside of your state, province, country or other governmental jurisdiction where the data

            protection laws may differ than those from your jurisdiction.

        </p>

        <p>If you are located outside the United States and choose to provide information to us, please note

            that we transfer the data, including Personal Data, to India and process it there.

        </p>

        <p>Your consent to this Privacy Policy followed by your submission of such information represents your

            agreement to that transfer.

        </p>

        <p>BOLTZMANN Labs will take all steps reasonably necessary to ensure that your data is treated securely

            and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to

            an organization or a country unless there are adequate controls in place including the security of

            your data and other personal information.

        </p>

        <h3 class="priv-h3"style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}} >Disclosure of Data </h3>



        <h4 class="priv-h4" style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Disclosure for Law Enforcement</h4>

        <p>Under certain circumstances, BOLTZMANN Labs may be required to disclose your Personal Data if

            required to do so by law or in response to valid requests by public authorities (e.g. a court or a

            government agency).

        </p>

        <h4 class="priv-h4" style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Legal Requirements</h4>

        <span>BOLTZMANN Labs may disclose your Personal Data in the good faith belief that such action is

            necessary to:

        </span>

        <ul>

            <li>To comply with a legal obligation

            </li>

            <li>To protect and defend the rights or property of BOLTZMANN Labs

            </li>

            <li>To prevent or investigate possible wrongdoing in connection with the Service

            </li>

            <li>To protect the personal safety of users of the Service or the public

            </li>

            <li>To protect against legal liability

            </li>

        </ul>

        <h4 class="priv-h4"style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Security of Data </h4>

        <p>The security of your data is important to us, but remember that no method of transmission over the

            Internet, or method of electronic storage is 100% secure. While we strive to use commercially

            acceptable means to protect your Personal Data, we cannot guarantee its absolute security.

        </p>

        <h4 class="priv-h4"style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>“Do Not Track” Signals</h4>

        <p>We do not support Do Not Track (“DNT”). Do Not Track is a preference you can set in your web browser

            to inform websites that you do not want to be tracked.

        </p>

        <p>You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web

            browser.

        </p>



        <h4 class="priv-h4"style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Your Data Protection Rights Under General Data Protection Regulation (GDPR)</h4>

        <p>If you are a resident of the European Economic Area (EEA), you have certain data protection rights.

            BOLTZMANN Labs aims to take reasonable steps to allow you to correct, amend, delete, or limit the

            use of your Personal Data.

        </p>

        <p>If you wish to be informed what Personal Data we hold about you and if you want it to be removed from

            our systems, please contact us.

        </p>

        <span>In certain circumstances, you have the following data protection rights:

        </span>

        <p> <span>The right to access, update or to delete the information we have on you.</span> Whenever made

            possible, you can access, update or request deletion of your Personal Data directly within your

            account settings section. If you are unable to perform these actions yourself, please contact us to

            assist you.

        </p>

        <p><span>The right of rectification.</span> You have the right to have your information rectified if

            that information is inaccurate or incomplete.

        </p>

        <p><span>The right to object.</span> You have the right to object to our processing of your Personal

            Data.

        </p>

        <p><span>The right of restriction. </span> You have the right to request that we restrict the processing

            of your personal information.

        </p>

        <p><span>The right to data portability.</span> You have the right to be provided with a copy of the

            information we have on you in a structured, machine-readable and commonly used format.

        </p>

        <p><span>The right to withdraw consent.</span> You also have the right to withdraw your consent at any

            time where BOLTZMANN Labs relied on your consent to process your personal information.

        </p>

        <span>Please note that we may ask you to verify your identity before responding to such requests.

        </span>

        <span>You have the right to complain to a Data Protection Authority about our collection and use of your

            Personal Data. For more information, please contact your local data protection authority in the

            European Economic Area (EEA).

        </span>



        <h4 class="priv-h4"style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}> Service Providers

        </h4>

        <p>We may employ third party companies and individuals to facilitate our Service (“Service Providers”),

            to provide the Service on our behalf, to perform Service-related services or to assist us in

            analyzing how our Service is used.

        </p>

        <p>These third parties have access to your Personal Data only to perform these tasks on our behalf and

            are obligated not to disclose or use it for any other purpose.

        </p>

        <h4 class="priv-h4"style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Analytics</h4>

        <p>We may use third-party Service Providers to monitor and analyze the use of our Service. </p>

        <span>Google Analytics</span>

        <p> Google Analytics is a web analytics service offered by Google that tracks and reports website

            traffic. Google uses the data collected to track and monitor the use of our Service. This data is

            shared with other Google services. Google may use the collected data to contextualize and

            personalize the ads of its own advertising network. You can opt-out of having made your activity on

            the Service available to Google Analytics by installing the Google Analytics opt-out browser add-on.

            The add-on prevents the Google Analytics JavaScript (ga.js, analytics.js, and dc.js) from sharing

            information with Google Analytics about visits activity. For more information on the privacy

            practices of Google, please visit the Google Privacy & Terms web page:

            <a href="https://policies.google.com/privacy?hl=en">https://policies.google.com/privacy?hl=en</a>

        </p>

        <span>Links to Other Sites</span>

        <p>Our Service may contain links to other sites that are not operated by us. If you click on a third

            party

            link, you will be directed to that third party’s site. We strongly advise you to review the Privacy

            Policy of every site you visit.</p>

        <p> We have no control over and assume no responsibility for the content, privacy policies or practices

            of

            any third party sites or services.</p>

        <h4 class="priv-h4"style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Children’s Privacy</h4>

        <p>Our Service does not address anyone under the age of 18 (“Children”). We do not knowingly collect

            personally identifiable information from anyone under the age of 18. If you are a parent or guardian

            and you are aware that your child has provided us with Personal Data, please contact us. If we

            become aware that we have collected Personal Data from children without verification of parental

            consent, we take steps to remove that information from our servers.

        </p>

        <h4 class="priv-h4"style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Changes to This Privacy Policy </h4>

        <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the

            new Privacy Policy on this page. </p>

        <p>We will let you know via email and/or a prominent notice on our Service, prior to the change becoming

            effective and update the “effective date” at the top of this Privacy Policy.</p>

        <p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy

            Policy are effective when they are posted on this page. </p>

        <p>This site is protected by reCAPTCHA and the Google Privacy Policy

            (https://policies.google.com/privacy) and Terms of Service (https://policies.google.com/terms)

            apply.</p>



        <h4 class="priv-h4" style ={{color: '#501f84', fontWeight:'normal',textDecoration:'none'}}>Contact Us </h4>

        <p>If you have any questions about this Privacy Policy, please contact us:

        </p>

        <p>By email: <a href="mailto:contact@boltzamnn.co">contact@boltzamnn.co</a>

        </p>

        <span style={{fontSize:'small'}}>Copyright © 2023 BOLTZMANN Labs Private Limited All rights reserved.

        </span>

    </div>

</section>



</main>

)
}

export default Privacy